(() => {
  const STORAGE_KEY = "kaboomBrandLogo";
  const MAX_FILE_SIZE = 2 * 1024 * 1024;

  function isMobile() {
  return window.matchMedia("(max-width: 749px)").matches ||
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

  function startBrandManager() {
    if (document.querySelector(".kaboom-brand-manager")) {
      return;
    }

    injectStyles();

    const manager = document.createElement("div");
    manager.className = "kaboom-brand-manager";

    manager.innerHTML = `
      <input
        class="kaboom-brand-manager__input"
        type="file"
        accept=".png,.jpg,.jpeg,.webp,.svg,image/png,image/jpeg,image/webp,image/svg+xml"
      >

      <!-- Default state -->
      <div class="kaboom-brand-manager__main">
  <button class="kaboom-brand-manager__add" type="button" aria-label="Preview your logo">
    <span class="kaboom-brand-manager__icon" aria-hidden="true">+</span>
    <span class="kaboom-brand-manager__label">
      <span>Preview your logo</span>
      <small class="kaboom-brand-manager__count-line" hidden></small>
    </span>
  </button>
  <button class="kaboom-brand-manager__info" type="button" aria-label="How logo preview works" title="How logo preview works">i</button>
</div>

      <!-- Active state -->
      <div class="kaboom-brand-manager__active" aria-live="polite" hidden>
  <div class="kaboom-brand-manager__status">
    <span class="kaboom-brand-manager__tick" aria-hidden="true">✓</span>
    <span>Showing your branding</span>
  </div>

  <small class="kaboom-brand-manager__count-line kaboom-brand-manager__count-line--active" hidden></small>

  <div class="kaboom-brand-manager__actions">
    <button class="kaboom-brand-manager__replace" type="button">Replace</button>
    <span aria-hidden="true">•</span>
    <button class="kaboom-brand-manager__remove" type="button">Remove</button>
  </div>

  <button class="kaboom-brand-manager__info kaboom-brand-manager__info--active" type="button" aria-label="How logo preview works" title="How logo preview works">i</button>
</div>

      <div class="kaboom-brand-manager__message" role="alert" hidden></div>
    `;

    document.body.appendChild(manager);

    // Info panel
    const panelOverlay = document.createElement("div");
    panelOverlay.className = "kaboom-brand-info-overlay";
    panelOverlay.hidden = true;

    const panel = document.createElement("div");
    panel.className = "kaboom-brand-info-panel";
    panel.innerHTML = `
      <div class="kaboom-brand-info-panel__handle"></div>
      <h3 class="kaboom-brand-info-panel__title">How logo preview works</h3>
      <div class="kaboom-brand-info-panel__body">
        <p>Upload your logo once and we’ll show a live preview on products that support it.</p>
        <p>Each product has one designated colour for this quick preview.</p>
        <p>Want a different colour or decoration style?<br>
        Use the product calculator and request a free quote/proof — our studio will create it for you.</p>
        <p class="kaboom-brand-info-panel__tip"><strong>Best results:</strong> Use a logo with a transparent or white background. White or very light logos on light products may not show clearly.</p>
        <p class="kaboom-brand-info-panel__count"></p>
      </div>
      <button type="button" class="kaboom-brand-info-panel__close">Got it</button>
    `;

    document.body.appendChild(panelOverlay);
    document.body.appendChild(panel);

    const fileInput = manager.querySelector(".kaboom-brand-manager__input");
    const addButton = manager.querySelector(".kaboom-brand-manager__add");
    const activePanel = manager.querySelector(".kaboom-brand-manager__active");
    const replaceButton = manager.querySelector(".kaboom-brand-manager__replace");
    const removeButton = manager.querySelector(".kaboom-brand-manager__remove");
    const message = manager.querySelector(".kaboom-brand-manager__message");
    const countEl = panel.querySelector(".kaboom-brand-info-panel__count");
    const closePanelBtn = panel.querySelector(".kaboom-brand-info-panel__close");
    const infoButtons = manager.querySelectorAll(".kaboom-brand-manager__info");

    function hasSavedLogo() {
      return Boolean(localStorage.getItem(STORAGE_KEY));
    }

    function updateManagerState() {
      const logoIsActive = hasSavedLogo();

      manager.querySelector(".kaboom-brand-manager__main").hidden = logoIsActive;
      activePanel.hidden = !logoIsActive;

      if (logoIsActive) {
        manager.classList.add("kaboom-brand-manager--active");
      } else {
        manager.classList.remove("kaboom-brand-manager--active");
      }
    }

    function showMessage(text) {
      message.textContent = text;
      message.hidden = false;
      window.clearTimeout(showMessage.timeout);
      showMessage.timeout = window.setTimeout(() => {
        message.hidden = true;
        message.textContent = "";
      }, 5000);
    }

    function openFilePicker(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // On mobile → just show a simple message
  if (isMobile()) {
    showMessage("Feature only available on desktop");
    return;
  }

  message.hidden = true;
  message.textContent = "";
  fileInput.value = "";

  window.setTimeout(() => {
    fileInput.click();
  }, 50);
}

    function fileIsSupported(file) {
      const supportedTypes = ["image/png", "image/jpeg", "image/webp", "image/svg+xml"];
      if (supportedTypes.includes(file.type)) return true;
      return /\.(png|jpe?g|webp|svg)$/i.test(file.name);
    }

    function saveLogo(logoSource) {
  try {
    localStorage.setItem(STORAGE_KEY, logoSource);
  } catch (error) {
    console.error("Kaboom could not save the customer logo", error);
    showMessage("That logo could not be saved. Please try a smaller file.");
    return;
  }

  const apply = () => {
    if (window.KaboomBrandPreview?.setLogo) {
      window.KaboomBrandPreview.setLogo(logoSource);
    }
    updateManagerState();
    window.dispatchEvent(
      new CustomEvent("kaboom:brand-logo-change", {
        detail: { active: true, logoSource }
      })
    );
  };

  if (typeof window.KaboomLoadBrandScripts === "function") {
    window.KaboomLoadBrandScripts()
      .then(apply)
      .catch(() => {
        showMessage("Preview scripts could not be loaded. Please refresh and try again.");
      });
  } else {
    apply();
  }
}

    function removeLogo() {
      localStorage.removeItem(STORAGE_KEY);

      if (window.KaboomBrandPreview?.clearLogo) {
        window.KaboomBrandPreview.clearLogo();
      }

      updateManagerState();

      window.dispatchEvent(
        new CustomEvent("kaboom:brand-logo-change", {
          detail: { active: false, logoSource: null }
        })
      );
    }

    function handleFile(file) {
      if (!file) return;

      if (!fileIsSupported(file)) {
        showMessage("Please choose a PNG, JPG, WebP or SVG logo.");
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        showMessage("Please choose a logo smaller than 2 MB.");
        return;
      }

      const reader = new FileReader();

      reader.addEventListener("load", () => {
        if (typeof reader.result !== "string") {
          showMessage("That logo could not be read. Please try another file.");
          return;
        }
        saveLogo(reader.result);
      });

      reader.addEventListener("error", () => {
        showMessage("That logo could not be read. Please try another file.");
      });

      reader.readAsDataURL(file);
    }

    function updateCountLine() {
  const cards = document.querySelectorAll("product-card, .product-card");
  const totalCards = cards.length;
  let previewCards = 0;

  cards.forEach((card) => {
    const image = (card.getAttribute("data-brand-preview-image") || "").trim();
    const config = (card.getAttribute("data-brand-preview") || "").trim();

    // Only count cards that actually have real preview data
    if (image && image !== "" && config && config !== "null" && config !== "") {
      previewCards += 1;
    }
  });

  const isCollectionContext =
    document.body.classList.contains("template-collection") ||
    window.location.pathname.includes("/collections/") ||
    totalCards > 0;

  if (isCollectionContext && totalCards > 0) {
    countEl.textContent = `${previewCards} of ${totalCards} products in this collection support live logo preview`;
    return { previewCards, totalCards };
  }

  countEl.textContent = "Available on selected products · more coming soon";
  return { previewCards: 0, totalCards: 0 };
}

function updateButtonCount() {
  const { previewCards, totalCards } = updateCountLine();
  const text =
    totalCards > 0
      ? `${previewCards} of ${totalCards} support live preview`
      : "";

  manager.querySelectorAll(".kaboom-brand-manager__count-line").forEach((el) => {
    if (text) {
      el.textContent = text;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  });
}

    function openInfoPanel() {
      updateCountLine();
      panelOverlay.hidden = false;
      panel.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function closeInfoPanel() {
      panel.classList.remove("is-open");
      panelOverlay.hidden = true;
      document.body.style.overflow = "";
    }

    // Events
    addButton.addEventListener("click", openFilePicker);
    replaceButton.addEventListener("click", openFilePicker);
    removeButton.addEventListener("click", removeLogo);

    infoButtons.forEach((btn) => {
      btn.addEventListener("click", openInfoPanel);
    });

    closePanelBtn.addEventListener("click", closeInfoPanel);
    panelOverlay.addEventListener("click", closeInfoPanel);

    fileInput.addEventListener("change", () => {
      handleFile(fileInput.files?.[0]);
    });

    window.addEventListener("storage", (event) => {
      if (event.key === STORAGE_KEY) updateManagerState();
    });

        document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && panel.classList.contains("is-open")) {
        closeInfoPanel();
      }
    });

    updateManagerState();
    updateButtonCount();

    // Collection grids can load a moment later
    window.setTimeout(updateButtonCount, 800);
    window.setTimeout(updateButtonCount, 2000);
  }

  function injectStyles() {
    if (document.querySelector("#kaboom-brand-manager-styles")) return;

    const styles = document.createElement("style");
    styles.id = "kaboom-brand-manager-styles";

    styles.textContent = `
      .kaboom-brand-manager {
        position: fixed;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: inherit;
      }

      .kaboom-brand-manager button { font: inherit; }

      /* Visually hidden but still usable by mobile browsers */
      .kaboom-brand-manager__input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
        opacity: 0;
        pointer-events: none;
      }

      .kaboom-brand-manager__main {
        position: relative;
        display: inline-flex;
        align-items: center;
      }

      .kaboom-brand-manager__add {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        min-height: 50px;
        padding: 11px 22px 11px 18px;
        color: #fff;
        background: #111;
        border: 1px solid #111;
        border-radius: 999px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.25);
        cursor: pointer;
        font-weight: 700;
        line-height: 1.2;
        white-space: nowrap;
        transition: transform 150ms ease, box-shadow 150ms ease;
      }

      .kaboom-brand-manager__add:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0,0,0,0.3);
      }

      .kaboom-brand-manager__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        border: 1.5px solid currentColor;
        border-radius: 50%;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 21px;
        font-weight: 300;
        line-height: 24px;
        transform: translateY(-1px);
        transition: transform 180ms ease;
      }

      .kaboom-brand-manager__add:hover .kaboom-brand-manager__icon {
        transform: translateY(-1px) scale(1.1);
      }

      /* Info button */
      .kaboom-brand-manager__info {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
  max-width: 26px;
  max-height: 26px;
  aspect-ratio: 1 / 1;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #8ab7aa;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  padding: 0;
  margin: 0;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 150ms ease, background 150ms ease;
  z-index: 2;
}

.kaboom-brand-manager__label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
}

.kaboom-brand-manager__count-line {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.85;
  white-space: nowrap;
}

.kaboom-brand-manager__count-line--active {
  display: block;
  margin: 4px 0 2px;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.85;
  text-align: center;
}

      .kaboom-brand-manager__info:hover {
        transform: scale(1.1);
        background: #6f9e92;
      }

      /* Active state */
      .kaboom-brand-manager__active {
        position: relative;
        min-width: 245px;
        padding: 11px 20px 10px;
        color: #fff;
        background: #111;
        border: 1px solid #111;
        border-radius: 18px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.25);
        text-align: center;
      }

      .kaboom-brand-manager__status {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 7px;
        font-weight: 700;
        line-height: 1.25;
      }

      .kaboom-brand-manager__tick {
        display: grid;
        place-items: center;
        width: 20px;
        height: 20px;
        flex: 0 0 20px;
        color: #111;
        background: #fff;
        border-radius: 50%;
        font-size: 13px;
        line-height: 1;
        transform: translateY(-1px);
      }

      .kaboom-brand-manager__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        margin-top: 5px;
        color: rgba(255,255,255,0.7);
        font-size: 13px;
      }

      .kaboom-brand-manager__replace,
      .kaboom-brand-manager__remove {
        padding: 2px;
        color: #fff;
        background: transparent;
        border: 0;
        cursor: pointer;
        font-size: 13px;
        text-decoration: underline;
        text-underline-offset: 3px;
      }

      .kaboom-brand-manager__replace:hover,
      .kaboom-brand-manager__remove:hover {
        text-decoration-thickness: 2px;
      }

      .kaboom-brand-manager__message {
        position: absolute;
        left: 50%;
        bottom: calc(100% + 10px);
        width: max-content;
        max-width: min(320px, calc(100vw - 32px));
        transform: translateX(-50%);
        padding: 9px 13px;
        color: #fff;
        background: #b42318;
        border-radius: 8px;
        box-shadow: 0 4px 14px rgba(0,0,0,0.2);
        font-size: 13px;
        line-height: 1.35;
        text-align: center;
      }

      .kaboom-brand-manager [hidden] {
        display: none !important;
      }

      /* Info panel */
      .kaboom-brand-info-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        z-index: 10000;
        opacity: 0;
        transition: opacity 220ms ease;
      }

      .kaboom-brand-info-overlay:not([hidden]) {
        opacity: 1;
      }

      .kaboom-brand-info-panel {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10001;
        background: #fff;
        border-radius: 20px 20px 0 0;
        padding: 12px 22px 28px;
        box-shadow: 0 -8px 30px rgba(0,0,0,0.18);
        transform: translateY(110%);
        transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
        max-height: min(80vh, 560px);
        overflow-y: auto;
        font-family: inherit;
        color: #222;
      }

      .kaboom-brand-info-panel.is-open {
        transform: translateY(0);
      }

      .kaboom-brand-info-panel__handle {
        width: 42px;
        height: 4px;
        background: #ddd;
        border-radius: 4px;
        margin: 0 auto 18px;
      }

      .kaboom-brand-info-panel__title {
        margin: 0 0 14px;
        font-size: 18px;
        font-weight: 800;
        letter-spacing: -0.02em;
      }

      .kaboom-brand-info-panel__body p {
        margin: 0 0 12px;
        font-size: 14.5px;
        line-height: 1.5;
        color: #444;
      }

      .kaboom-brand-info-panel__tip {
        background: #f6f8f8;
        border-radius: 10px;
        padding: 12px 14px !important;
        font-size: 13.5px !important;
        color: #33404f !important;
      }

      .kaboom-brand-info-panel__count {
        margin-top: 16px !important;
        padding-top: 14px;
        border-top: 1px solid #eee;
        font-size: 13.5px !important;
        font-weight: 700;
        color: #33404f !important;
      }

      .kaboom-brand-info-panel__close {
        display: block;
        width: 100%;
        margin-top: 18px;
        padding: 14px;
        border: none;
        border-radius: 12px;
        background: #111;
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
      }

      .kaboom-brand-info-panel__close:hover {
        background: #333;
      }

      @media (max-width: 749px) {
        .kaboom-brand-manager { bottom: 14px; }

        .kaboom-brand-manager__add {
          min-height: 46px;
          padding: 10px 18px 10px 15px;
          gap: 9px;
          font-size: 14px;
        }

        .kaboom-brand-manager__icon {
          width: 22px;
          height: 22px;
          flex-basis: 22px;
          font-size: 19px;
          line-height: 22px;
        }

        .kaboom-brand-manager__info {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
  font-size: 12px;
  top: -7px;
  right: -7px;
}

        .kaboom-brand-manager__active {
          min-width: 220px;
          padding: 10px 16px 9px;
        }

        .kaboom-brand-info-panel {
          padding: 10px 18px 24px;
        }
      }
    `;

    document.head.appendChild(styles);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startBrandManager);
  } else {
    startBrandManager();
  }

    // If a logo is already saved, load the heavy scripts after the page is idle
  // so we don't hurt LCP / Speed Index
  if (localStorage.getItem(STORAGE_KEY)) {
    const run = () => {
      if (typeof window.KaboomLoadBrandScripts === "function") {
        window.KaboomLoadBrandScripts().then(() => {
          if (window.KaboomBrandPreview?.updatePreview) {
            window.KaboomBrandPreview.updatePreview();
          }
          if (window.KaboomCollectionPreview?.update) {
            window.KaboomCollectionPreview.update();
          }
        });
      }
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(run, { timeout: 2500 });
    } else {
      window.addEventListener("load", () => setTimeout(run, 1200));
    }
  }
})();